// removed by extract-text-webpack-plugin
module.exports = {"container":"_3L-G9XVtNL77ZCynMbsMhS","inner":"_3hOik5SKYrdbMAGERLiQFf","header":"_1R1wJ39fzyt-ZwxUsK2bKW UiOtkwjAwJvCk7RAufbT2","review-item-container":"_3x3sydnyFTEUzG78qvjcMf","reviews-wrapper":"_3SQ2KlrgO_Ds44EMbgwRmI","reviews-card-wrapper":"eKPArgE5vUHW1ZIiOdWFG","review-item":"_1wC1I9cUaJbDgF_Y1Em_JD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/FeaturedReviews.scss
// module id = 1197
// module chunks = 47